import logo from "../../../assets/images/logo.png";
import logoMain from "../../../assets/images/logo-main.png";
import logo1 from "../../../assets/images/logo-01.png";
import map from "../../../assets/images/map.jpg";
import one from "../../../assets/images/01.jpg";
import two from "../../../assets/images/02.jpg";
import three from "../../../assets/images/03.jpg";
import lading_banner from "../../../assets/images/lading-banner.jpg";
import results01 from "../../../assets/images/results/01.jpg";
import results02 from "../../../assets/images/results/02.jpg";
import results03 from "../../../assets/images/results/03.jpg";
import results04 from "../../../assets/images/results/04.jpg";
import results05 from "../../../assets/images/results/05.jpg";
import map1 from "../../../assets/images/map1.png";
import map2 from "../../../assets/images/map2.png";
import map3 from "../../../assets/images/map3.png";
import camera from "../../../assets/images/photocamera.png";
import config01 from "../../../assets/images/config/01.jpg";
import icon01 from "../../../assets/images/config/icon-01.svg";
import icon02 from "../../../assets/images/config/icon-02.svg";
import icon03 from "../../../assets/images/config/icon-03.svg";

import billicon01 from "../../../assets/images/result-01/icon-01.png";
import billicon02 from "../../../assets/images/result-01/icon-02.png";
import billimg01 from "../../../assets/images/result-01/01.jpg";
import billimg02 from "../../../assets/images/result-01/02.jpg";
import billimg03 from "../../../assets/images/result-01/03.jpg";
import billimg04 from "../../../assets/images/result-01/04.jpg";
import billimg05 from "../../../assets/images/result-01/05.jpg";
import billimg06 from "../../../assets/images/result-01/06.jpg";
import billimg07 from "../../../assets/images/result-01/07.jpg";
import billimg08 from "../../../assets/images/result-01/08.jpg";
import billimg09 from "../../../assets/images/result-01/09.jpg";
import billimg10 from "../../../assets/images/result-01/10.jpg";

import billboard01 from "../../../assets/images/result-02/01.jpg";
import billboard02 from "../../../assets/images/result-02/02.jpg";
import billboard03 from "../../../assets/images/result-02/03.jpg";
import billboard04 from "../../../assets/images/result-02/04.jpg";
import billboard05 from "../../../assets/images/result-02/05.jpg";
import billboard06 from "../../../assets/images/result-02/06.jpg";
import billboard07 from "../../../assets/images/result-02/07.jpg";
import billboard08 from "../../../assets/images/result-02/08.jpg";
import billboard09 from "../../../assets/images/result-02/09.jpg";
import billboard10 from "../../../assets/images/result-02/10.jpg";

import billboardbig01 from "../../../assets/images/result-big/01.jpg";
import billboardbig02 from "../../../assets/images/result-big/02.jpg";
import billboardbig03 from "../../../assets/images/result-big/03.jpg";
import billboardbig04 from "../../../assets/images/result-big/04.jpg";
import billboardbig05 from "../../../assets/images/result-big/05.jpg";
import billboardbig06 from "../../../assets/images/result-big/06.jpg";
import billboardbig07 from "../../../assets/images/result-big/07.jpg";
import billboardbig08 from "../../../assets/images/result-big/08.jpg";
import billboardbig09 from "../../../assets/images/result-big/09.jpg";
import billboardbig10 from "../../../assets/images/result-big/10.jpg";
import billboardbig11 from "../../../assets/images/result-big/11.jpg";
import billboardbig12 from "../../../assets/images/result-big/12.jpg";
import billboardbig13 from "../../../assets/images/result-big/13.jpg";

import billboardsm01 from "../../../assets/images/result-sm/01.jpg";
import billboardsm02 from "../../../assets/images/result-sm/02.jpg";
import billboardsm03 from "../../../assets/images/result-sm/03.jpg";
import billboardsm04 from "../../../assets/images/result-sm/04.jpg";
import billboardsm05 from "../../../assets/images/result-sm/05.jpg";
import billboardsm06 from "../../../assets/images/result-sm/06.jpg";
import billboardsm07 from "../../../assets/images/result-sm/07.jpg";
import billboardsm08 from "../../../assets/images/result-sm/08.jpg";
import billboardsm09 from "../../../assets/images/result-sm/09.jpg";
import billboardsm10 from "../../../assets/images/result-sm/10.jpg";
import billboardsm11 from "../../../assets/images/result-sm/11.jpg";
import billboardsm12 from "../../../assets/images/result-sm/12.jpg";
import billboardsm13 from "../../../assets/images/result-sm/13.jpg";
import billboardsm14 from "../../../assets/images/result-sm/14.jpg";
import billboardsm15 from "../../../assets/images/result-sm/15.jpg";
import billboardsm16 from "../../../assets/images/result-sm/16.jpg";
import billboardsm17 from "../../../assets/images/result-sm/17.jpg";
import billboardsm18 from "../../../assets/images/result-sm/18.jpg";
import billboardsm19 from "../../../assets/images/result-sm/19.jpg";
import billboardsm20 from "../../../assets/images/result-sm/20.jpg";

import main_image from "../../../assets/images/project-extra/main-image.jpg";
import map_icon from "../../../assets/images/project-extra/map.png";
import smile from "../../../assets/images/project-extra/smile.png";
import love from "../../../assets/images/project-extra/love.png";
import sad from "../../../assets/images/project-extra/sad.png";
import happy from "../../../assets/images/project-extra/happy.png";
import download from "../../../assets/images/project-extra/download.png";
import share from "../../../assets/images/project-extra/share.png";
import edit from "../../../assets/images/project-extra/edit.png";
import slider01 from "../../../assets/images/project-extra/slider-img/01.jpg";
import slider02 from "../../../assets/images/project-extra/slider-img/02.jpg";
import slider03 from "../../../assets/images/project-extra/slider-img/03.jpg";

import loading from "../../../assets/images/loading/loading.png";
import loadinggif from "../../../assets/images/loading/Ecesis-Tech.gif";
import loadingvideo from "../../../assets/images/loading/nayanz.mp4";
import nayanzloadgif from "../../../assets/images/loading/nayanz.gif";

import modalImage from "../../../assets/images/project-ready/01.jpg";

import share01 from "../../../assets/images/project-extra/share/01.png";
import share02 from "../../../assets/images/project-extra/share/02.png";
import share03 from "../../../assets/images/project-extra/share/03.png";
import share04 from "../../../assets/images/project-extra/share/04.png";
import share05 from "../../../assets/images/project-extra/share/05.png";
import share06 from "../../../assets/images/project-extra/share/06.png";
import chat from "../../../assets/images/project-extra/chat.png";
import chatnew from "../../../assets/images/project-extra/chat-new.png";

import attachment from "../../../assets/images/project-extra/attachment.svg";

import card_icon from "../../../assets/images/payment/card-icon.svg";
import card from "../../../assets/images/payment/card.png";

import facebook from "../../../assets/images/socialmedia/fb.svg";
import google from "../../../assets/images/socialmedia/google.svg";
import tweet from "../../../assets/images/socialmedia/tweet.svg";
import instagram from "../../../assets/images/socialmedia/instagram.svg";
import fb_white from "../../../assets/images/socialmedia/fb_white.svg";
import tweet_white from "../../../assets/images/socialmedia/tweet_white.svg";
import insta_white from "../../../assets/images/socialmedia/insta_white.svg";

import main_logo from "../../../assets/images/main-logo.png";
import img_01 from "../../../assets/images/marketplace/banner/img_01.png";
import img_02 from "../../../assets/images/marketplace/banner/img_02.png";
import img_03 from "../../../assets/images/marketplace/banner/img_03.png";
import img_04 from "../../../assets/images/marketplace/banner/img_04.png";
import img_05 from "../../../assets/images/marketplace/banner/img_05.png";

import filter from "../../../assets/images/icons/filter.svg";
import damage_road from "../../../assets/images/filters/damage_road.svg";
import injured_animals from "../../../assets/images/filters/injured_animals.svg";
import damage_buildings from "../../../assets/images/filters/damage_buildings.svg";
import traffic_light from "../../../assets/images/filters/traffic_light.svg";
import mango_tree from "../../../assets/images/filters/mango_tree.svg";

import category_01 from "../../../assets/images/marketplace/category_01.jpg";
import category_02 from "../../../assets/images/marketplace/category_02.png";
import category_03 from "../../../assets/images/marketplace/category_03.png";
import category_04 from "../../../assets/images/marketplace/category_04.png";
import category_05 from "../../../assets/images/marketplace/category_05.png";
import category_06 from "../../../assets/images/marketplace/category_06.png";
import category_07 from "../../../assets/images/marketplace/category_07.png";
import category_08 from "../../../assets/images/marketplace/category_08.png";
import category_09 from "../../../assets/images/marketplace/category_09.png";
import category_10 from "../../../assets/images/marketplace/category_10.png";
import category_11 from "../../../assets/images/marketplace/category_11.png";

import related_01 from "../../../assets/images/marketplace/related_01.jpg";
import related_02 from "../../../assets/images/marketplace/related_02.png";

import log from "../../../assets/images/log.png";

import direct_download from "../../../assets/images/marketplace/direct-download.png";

import about_01 from "../../../assets/images/about-us/img_01.jpg";
import about_02 from "../../../assets/images/about-us/img_02.jpg";
import videoposter from "../../../assets/images/about-us/videoposter.jpg";

import usecases01 from "../../../assets/images/use-cases/img_01.jpg";
import usecases02 from "../../../assets/images/use-cases/img_02.jpg";
import usecases03 from "../../../assets/images/use-cases/img_03.jpg";

import usecasedetail01 from "../../../assets/images/use-cases/detail/img_01.jpg";
import usecasedetail02 from "../../../assets/images/use-cases/detail/img_02.jpg";
import usecasedetail03 from "../../../assets/images/use-cases/detail/img_03.jpg";
import usecasedetail04 from "../../../assets/images/use-cases/detail/img_04.jpg";
import usecasedetail05 from "../../../assets/images/use-cases/detail/img_05.jpg";

import logo_white from "../../../assets/images/logo_white.png";
import android_app_icon from "../../../assets/images/android_app_icon.png";
import android_app_icon_no_shadow from "../../../assets/images/android_app_icon_no_shadow.png";

const Assets = {
  logo_white,
  android_app_icon,
  android_app_icon_no_shadow,
  usecasedetail01,
  usecasedetail02,
  usecasedetail03,
  usecasedetail04,
  usecasedetail05,
  usecases01,
  usecases02,
  usecases03,
  videoposter,
  about_01,
  about_02,
  log,
  fb_white,
  tweet_white,
  insta_white,
  damage_road,
  injured_animals,
  damage_buildings,
  mango_tree,
  traffic_light,
  filter,
  category_01,
  category_02,
  category_03,
  category_04,
  category_05,
  category_06,
  category_07,
  category_08,
  category_09,
  category_10,
  category_11,
  related_01,
  related_02,
  direct_download,
  img_01,
  img_02,
  img_03,
  img_04,
  img_05,
  logo1,
  map1,
  map2,
  map3,
  one,
  two,
  three,
  map,
  logo,
  logoMain,
  lading_banner,
  results01,
  results02,
  results03,
  results04,
  results05,
  camera,
  config01,
  icon01,
  icon02,
  icon03,
  billicon01,
  billicon02,
  billimg01,
  billimg02,
  billimg03,
  billimg04,
  billimg05,
  billimg06,
  billimg07,
  billimg08,
  billimg09,
  billimg10,

  billboard01,
  billboard02,
  billboard03,
  billboard04,
  billboard05,
  billboard06,
  billboard07,
  billboard08,
  billboard09,
  billboard10,

  billboardbig01,
  billboardbig02,
  billboardbig03,
  billboardbig04,
  billboardbig05,
  billboardbig06,
  billboardbig07,
  billboardbig08,
  billboardbig09,
  billboardbig10,
  billboardbig11,
  billboardbig12,
  billboardbig13,

  billboardsm01,
  billboardsm02,
  billboardsm03,
  billboardsm04,
  billboardsm05,
  billboardsm06,
  billboardsm07,
  billboardsm08,
  billboardsm09,
  billboardsm10,
  billboardsm11,
  billboardsm12,
  billboardsm13,
  billboardsm14,
  billboardsm15,
  billboardsm16,
  billboardsm17,
  billboardsm18,
  billboardsm19,
  billboardsm20,

  main_image,
  smile,
  love,
  sad,
  happy,
  download,
  share,
  edit,
  slider01,
  slider02,
  slider03,
  map_icon,
  loading,
  modalImage,

  share01,
  share02,
  share03,
  share04,
  share05,
  share06,

  attachment,

  card_icon,
  card,
  chat,
  loadinggif,
  loadingvideo,
  nayanzloadgif,

  facebook,
  google,
  chatnew,
  instagram,
  tweet,

  main_logo,
};

export default Assets;
